<template>
    <div class="layout-wrapper">
        <div class="translatorDetection" ref="translatorDetection">{{ translatorDetectionText }}</div>
        <div class="layout-inner">
            <layout-sidenav :class="{isExpanded:isSidenavExpanded}"/>

            <div class="layout-container">
                <layout-header @sidenav="isSidenavExpanded=!isSidenavExpanded"/>

                <div class="layout-content">
                    <div class="pending-screen" v-if="$parent.pageState=='pending'"></div>
                    <transition name="layout-content-transition" mode="out-in">
                        <router-view :key="key"
                                     :class="{'layout-content-route':1, pending:$parent.pageState=='pending'}"/>
                    </transition>
                </div>
                <layout-footer :currentObjectDetails="currentObjectDetails"/>
            </div>
        </div>
        <div class="layout-overlay" :class="{isActive:isSidenavExpanded}" @click="isSidenavExpanded=false"></div>
    </div>
</template>
<script>
import LayoutHeader from "./LayoutHeader";
import LayoutFooter from "./LayoutFooter";
import LayoutSidenav from "./LayoutSidenav";
import {__BUILD_COMMIT_HASH__} from "../../../version";
import {Server} from "@/common/server/server";

export default {
    components: {
        LayoutHeader, LayoutFooter, LayoutSidenav
    },
    props: {
        currentObjectDetails: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isSidenavExpanded: false,
            translatorDetectionText: 'Wykrywanie automatycznego tłumaczenia, automated translation detection',
            translatorDetected: false
        }
    },
    mounted() {
        setTimeout(() => this.detectTranslation(), 2000);
    },
    methods: {
        detectTranslation() {
            if (this.$refs.translatorDetection) {
                if (this.$refs.translatorDetection.textContent != this.translatorDetectionText) {
                    this.translatorDetected = true
                }
            }
        }
    },
    computed: {
        key() {
            if (this.$route.name == 'ScheduleSummary') {
                return '/schedule'
            } else {
                const importantQueryItems = Object.entries(this.$route.query).filter(([k, v]) => !k.startsWith('filter.') && k !== 'tab' && !k.startsWith('tab.'));
                return JSON.stringify({path: this.$route.path, query: importantQueryItems})
            }
        }
    },
    watch: {
        '$route.fullPath'() {
            this.detectTranslation()
            if (window.__BACKEND_COMMIT_HASH__ && window.__BACKEND_COMMIT_HASH__ !== __BUILD_COMMIT_HASH__) {
                window.location.reload();
            }

            try {
                window.scroll({top: 0, behavior: "smooth"})
            } catch (ex) {
                //srafari?
                window.scroll(0, 0)
            }
        },
        translatorDetected: {
            immediate: true,
            handler(x) {
                if (x) {
                    this.$store.commit('showNotification', {
                        text: this.$t('common.translatorDetected'),
                        type: 'warning'
                    });
                }
            }
        }
    }
}
</script>
<style>

</style>
